import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTheme } from '../../hooks/useTheme';
import { useLanguage } from '../../hooks/useLanguage';
import { Icon } from './Icon';
import { content } from '../../data/content';

export const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label="Toggle theme"
      title={isDark ? 'Switch to light' : 'Switch to dark'}
      className={`relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-app overflow-hidden transition-colors hover:bg-elev ${className}`}
      style={{ borderColor: 'var(--border-strong)' }}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={theme}
          initial={{ opacity: 0, rotate: -90, scale: 0.6 }}
          animate={{ opacity: 1, rotate: 0, scale: 1 }}
          exit={{ opacity: 0, rotate: 90, scale: 0.6 }}
          transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
          className="text-app"
        >
          <Icon name={isDark ? 'sun' : 'moon'} size={16} />
        </motion.span>
      </AnimatePresence>
    </button>
  );
};

export const LanguageToggle = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();
  const t = content[language];
  return (
    <button
      type="button"
      onClick={toggleLanguage}
      aria-label={t.nav.switchLang}
      title={t.nav.switchLang}
      className={`relative inline-flex items-center gap-2 h-9 rounded-full border border-app px-3 text-xs font-semibold tracking-wide text-app transition-colors hover:bg-elev ${className}`}
      style={{ borderColor: 'var(--border-strong)' }}
    >
      <Icon name="globe" size={14} />
      <span className="text-mono">{language === 'en' ? 'EN' : 'DE'}</span>
      <span className="text-subtle text-[0.7rem]">/</span>
      <span className="text-mono text-subtle">{language === 'en' ? 'DE' : 'EN'}</span>
    </button>
  );
};
